<template>
  <Row style="padding: 20px">
    <Col span="24" v-if="$route.query.is_diff == 1">
      <Tag color="blue" size="large" v-if="$route.query.wmsName">{{
        $route.query.wmsName || ""
      }}</Tag>
      <Tag color="blue" size="large" v-if="$route.query.skuName">{{
        $route.query.skuName || ""
      }}</Tag>
      <div class="return_a">
        <router-link
          :to="{
            path: '/inventoryEdit',
            query: {
              shipToCode: $route.query.shipToCode,
              wmsCode: $route.query.wmsCode,
            },
          }"
          >返回</router-link
        >
      </div>
    </Col>
    <Col span="24" v-else>
      <div style="text-align: right">
        <router-link :to="{ path: '/warehouseProduct' }">返回</router-link>
      </div>
      <table>
        <tr>
          <th colspan="7">服务商仓库商品</th>
        </tr>
        <tr>
          <th>服务商</th>
          <td>{{ $route.query.spName }}</td>
          <th>仓库</th>
          <td>{{ $route.query.wmsName }}</td>
          <th>服务商商品</th>
          <td>{{ $route.query.skuName }}</td>
        </tr>
        <tr>
          <th>经销商商品编码</th>
          <td>{{ $route.query.spCode }}</td>
          <th>商品仓库库存</th>
          <td>{{ $route.query.skuNum }}</td>
          <th>状态</th>
          <td :style="$route.query.status=='03'&&'color:red'">{{ $route.query.status=='02'?'上架':'下架' }}</td>
        </tr>
      </table>
    </Col>
    <Col span="24">
      <Table
        class="table"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="wmsHistoryList.data || []"
      >
        <template slot-scope="{ index }" slot="no">
          <!-- <span>{{ params.pageSize * (params.page - 1) + index + 1 }}</span> -->
          <span>{{ index + 1 }}</span>
        </template>
      </Table>
    </Col>
  </Row>
</template>
<script>
import { mapGetters } from "vuex";
const columns = [
  {
    title: "序号",
    slot: "no",
    width: 80,
  },
  {
    title: "ID",
    key: "id",
  },
  {
    title: "省份",
    key: "areaName",
  },
  {
    title: "省份编码",
    key: "areaCode",
  },
  {
    title: "分类",
    key: "changeEvent",
  },
  {
    title: "类型",
    key: "changeType",
  },
  {
    title: "数量",
    key: "count",
  },
  {
    title: "服务商名称",
    key: "fwName",
  },
  //   {
  //     title: "服务商编码",
  //     key: "spCode",
  //   },
  {
    title: "GRADE GROUP",
    key: "gradeGroup",
  },
  //   {
  //     title: "skuCode",
  //     key: "skuCode",
  //   },
  // {
  //   title: "skuName",
  //   key: "skuName",
  // },
  // {
  //   title: "仓库名称",
  //   key: "wmsName",
  // },
  // {
  //   title: "创建时间",
  //   key: "createtime",
  // },
  {
    title: "更新时间",
    key: "updatetime",
  },
  {
    title: "备注",
    key: "remark",
  },
  //   {
  //     title: "操作",
  //     slot: "action"
  //   },
];
export default {
  data() {
    return {
      loading: false,
      columns,
      wmsCodeList: [],
      areaCodeList: [],
      params: {
        pageSize: 9999,
        page: 1,
        changeEvent: "", //采购入库,下单扣除 回滚
        areaCode: "",
        gradeGroup: "",
        skuCode: "",
        spCode: "",
        wmsCode: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      wmsHistoryList: "warehouse/getWmsHistoryList",
    }),
  },
  created() {
    this.params = Object.assign(this.params, this.$route.query);
    if (this.params.is_diff) {
      delete this.params.is_diff;
    }
    if (this.params.spName) {
      delete this.params.spName;
    }
    if (this.params.spCode) {
      delete this.params.spCode;
    }
    if (this.params.skuNum) {
      delete this.params.skuNum;
    }
    if (this.params.status) {
      delete this.params.status;
    }
    this.getList();
  },
  methods: {
    // 列表
    getList() {
      this.loading = true;
      this.$store
        .dispatch("warehouse/getWmsHistoryList", this.params)
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 页码
    pageNumChange(pageNum) {
      this.params.page = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.params.pageSize = pageSize;
      // 页码变动触发pageNumChange
      if (this.params.page == 1) {
        this.getList();
      } else {
        this.params.page = 1;
      }
    },
    // 重置
    resetList() {
      this.params.page = 1;
      this.params.pageSize = 10;
      this.params.areaCode = "";
      this.params.changeEvent = "";
      this.params.gradeGroup = "";
      this.params.skuCode = "";
      this.params.spCode = "";
      this.params.wmsCode = "";
      this.getList();
    },
  },
};
</script>
<style scoped>
.search {
  margin-right: 15px;
  width: 300px;
}
.add {
  float: right;
  margin-right: 0;
  margin-left: 15px;
}
.table {
  margin-top: 10px;
}
.formEach {
  display: flex;
  margin-bottom: 10px;
  position: relative;
  padding-left: 20px;
}
.formEach > span {
  line-height: 30px;
  width: 80px;
}
.formEach > span::before {
  content: "*";
  color: brown;
}
.formEach > .noq::before {
  opacity: 0;
}
.return_a {
  text-align: right;
  margin-top: -22px;
  margin-bottom: 10px;
}

table {
  width: 100%;
  margin-top: 10px;
  border-collapse: collapse;
}

th,
td {
  padding: 0 10px;
  text-align: center;
  border: 1px solid #dcdee2;
  line-height: 30px;
  color: #515a6e;
  font-size: 12px;
}

th {
  background: #f8f8f9;
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/inventoryLogByProduct.vue